import {
  faArrowLeft,
  faArrowUp,
  faClose,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import classNames, { Value as ClassValue } from "classnames";
import { ButtonIcon } from "Components/Icon";
import React, { ButtonHTMLAttributes } from "react";
import { isNodeEmpty } from "Tools";

interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className"> {
  className?: ClassValue;
  isSubmitting?: boolean;
}

export function BulmaButton({ isSubmitting, ...props }: ButtonProps) {
  return (
    <button
      type="button"
      disabled={isSubmitting}
      {...props}
      className={classNames(props.className, "button", {
        "is-loading": isSubmitting,
      })}
    >
      {props.children}
    </button>
  );
}

export function CancelButton(props: ButtonProps) {
  return (
    <BulmaButton className="is-light" {...props}>
      <ButtonIcon icon={faClose} />
      <span>{!isNodeEmpty(props.children) ? props.children : "Cancel"}</span>
    </BulmaButton>
  );
}

export function SaveButton(props: ButtonProps) {
  return (
    <BulmaButton className="is-primary" {...props}>
      <ButtonIcon icon={faSave} />
      <span>{!isNodeEmpty(props.children) ? props.children : "Save"}</span>
    </BulmaButton>
  );
}

export function SubmitButton(props: ButtonProps) {
  return (
    <BulmaButton className="is-primary" {...props}>
      <span>{!isNodeEmpty(props.children) ? props.children : "Submit"}</span>
    </BulmaButton>
  );
}

export function BackButton(props: ButtonProps) {
  return (
    <BulmaButton className="is-light" {...props}>
      <ButtonIcon icon={faArrowLeft} />
      <span>{!isNodeEmpty(props.children) ? props.children : "Back"}</span>
    </BulmaButton>
  );
}

export function ContinueButton(props: ButtonProps) {
  return (
    <BulmaButton className="is-primary" {...props}>
      <span>{!isNodeEmpty(props.children) ? props.children : "Continue"}</span>
      <ButtonIcon icon={faArrowUp} />
    </BulmaButton>
  );
}
